import React from 'react'
import { useNavigate } from 'react-router-dom';
import { REDIRECT_KEY } from "../../constents/text";
import { NOT_TO_RECORD_AS_REDIRECT_URLS } from '../../Utils/routes';

const useRedirect = () => {

    const Navigate = useNavigate();


    const redirectUrlSetter = () => {
        const url = window.location.pathname + window.location.search;
        if (!NOT_TO_RECORD_AS_REDIRECT_URLS.includes(window.location.pathname)) {
            window.sessionStorage.setItem(REDIRECT_KEY, url);
        }
    }
    const redirect = () => {
        const url = window.sessionStorage.getItem(REDIRECT_KEY);
        window.sessionStorage.removeItem(REDIRECT_KEY);

        // const mockUrl = `/mock`;
        // console.log(url);
        
        if (url?.startsWith('/mock')) {
            // Full reload for /mock route
            window.location.href = url;
        } else {
            // React Router navigation for other routes
            Navigate(url ?? '/dashboard');
        }
        // window.location.href = url ?? '/dashboard';
    };

    return { redirectUrlSetter, redirect };
}

export default useRedirect;